import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=0de9bdda&scoped=true&"
import script from "@/scripts/Password/Confirm/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Password/Confirm/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de9bdda",
  null
  
)

export default component.exports